import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from 'moment';
import { DotLoader, DotLoaderOverlay } from 'react-spinner-overlay';
import { SnackbarProvider, useSnackbar } from 'notistack';

/** MUI */
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import proyectoService from '../services/proyecto.service';
import usuarioService from '../services/usuario.service';

/** Servicios */
import personaService from "../services/persona.service";
import mutuoService from "../services/mutuo.service";
import emailService from "../services/email.service";

/** Definiciones */
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const MutuoADC = () => {
    const [persona, setPersona] = useState('');
    const { rut } = useParams();
    const [expanded, setExpanded] = useState(false);
    const [comentario, setComentario] = useState('');
    const user = JSON.parse(localStorage.getItem('user'));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!user) return navigate("/login");
        retreviePersona(rut);
    }, []);

    async function retreviePersona(_rut) {
        setLoading(true);
        try {
            const pers = await personaService.getPorRut(_rut);
            setPersona(pers.data[0]);
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const enviar = () => {
        if (!comentario) {
            alert("Debe ingresar un comentario!!");
            return;
        } else {
            setLoading(true);
            console.log("Comentario", comentario, "Usuario", user);
            mutuoService.ingresar({ comentario_inicial: comentario, correo_usuario: user.user.correo, personaId: persona.id })
                .then(response => {
                    console.log(response);
                    var html = crearHtmlMutuoAcuerdo(new Date(), response.data.id,persona);
                    const data_email = {
                        mensaje: html,
                        email: ["plagues@ecora.cl","grojas@ecora.cl"]
                    }
                    emailService.sendMailMutuo(data_email)
                    .then(resp=>{
                        console.log(resp);
                        setLoading(false);
                        enqueueSnackbar("Solicitud enviada correctamente!", {variant: "success"});
                        setTimeout(()=>{
                            navigate("/salidar");
                        }, 2000);
                    }).catch(err=>{
                        console.error(err);
                        setLoading(false);
                    })
                }).catch(err => {
                    console.error(err);
                    setLoading(false);
                    enqueueSnackbar("Ocurrio un error al enviar la solicitud!", {variant: "error"});
                });
        }
    };

    function crearHtmlMutuoAcuerdo(fecha, id_mutuo, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Solicitud de Información de Mutuo Acuerdo</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una Solicitud de Información de Mutuo Acuerdo para la persona: ${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</p><p>Para su revisón, por favor ir al siguiente Link: <a href="${baseurl}/mutuofinanzas/${id_mutuo}">REVISAR MUTUO ACUERDO</a></p> \n`;
        html = html + "</div>";
        return html;
    }


    return (
        <Container component="main" maxWidth="xs">
            {loading ? (
                <DotLoaderOverlay size={28} message="Cargando..." color="#4F8BFA" />
            ) : ""}
            <Card sx={{ maxWidth: 600 }}>
                <CardHeader
                    avatar={
                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                            {persona ? persona.perNombre1.charAt(0).toUpperCase() : ""}
                        </Avatar>
                    }
                    /* action={
                        <IconButton aria-label="settings">
                            <MoreVertIcon />
                        </IconButton>
                    } */
                    title={persona.perNombre1 + " " + persona.perApPaterno + " " + persona.perApMaterno}
                    subheader={persona.Rut}
                />
                <CardMedia
                    component="img"
                    height="194"
                    image="/logo512.png"
                    alt="Ecora S.A."
                />
                <CardContent>
                    <Typography variant="body2" color="text.secondary">
                        {/* <p><strong>Causal:</strong> {causal.descripcion}</p>
                        <p><strong>Comentarios:</strong> {causal.comentario}</p>
                        <p><strong>Evaluación:</strong> {causal.evaluacion}</p>
                        <p><strong>Fecha Ingreso Desvinculación:</strong> {moment(causal.fecha_ingreso).format("DD-MM-YYYY")}</p> */}
                    </Typography>
                </CardContent>
                <Typography variant='6' sx={{
                    fontStyle: "inherit",
                    fontWeight: "bold",
                    textAlign: "center"
                }} paragraph>
                    Datos Trabajador
                </Typography>
                <CardContent>
                    <Typography paragraph>
                        <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                        <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                        <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                    </Typography>
                </CardContent>
                <Box sx={{
                    margin: 3,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <Typography variant='6' sx={{
                        fontStyle: "inherit",
                        fontWeight: "bold",
                        textAlign: "left"
                    }} paragraph>
                        Ingrese sus comentarios:
                    </Typography>
                    <TextField
                        label="Comentarios"
                        fullWidth
                        multiline
                        rows={4}
                        onChange={(e) => setComentario(e.target.value)}
                    />
                </Box>
                <Box sx={{
                    margin: 3,
                    alignItems: 'end',
                    justifyContent: 'end',
                    display: 'flex'
                }}>
                    <Button variant="contained" color="success" onClick={enviar}>Enviar</Button>
                </Box>
                {/* <CardActions disableSpacing>

                    <IconButton aria-label="add to favorites">
                        <FavoriteIcon />
                    </IconButton>
                    <IconButton aria-label="share">
                        <ShareIcon />
                    </IconButton>
                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>
                </CardActions> */}
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography paragraph>
                            <p><strong>Unidad de Negocio:</strong> {persona.ctoDescripcion}</p>
                            <p><strong>Cargo:</strong> {persona.recDescripcion}</p>
                            <p><strong>Fecha de Contrato:</strong> {moment(persona.FechaContratoInicial).format("DD-MM-YYYY")}</p>
                        </Typography>
                    </CardContent>
                </Collapse>
            </Card>
        </Container>
    )
}

export default function MutuoADCSnack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <MutuoADC />
        </SnackbarProvider>
    )
};